import type { KnowledgeIndexStatus, KnowledgeIndexTrigger } from './types'

export const CHATBOT_KNOWLEDGE_ENDPOINT = 'office/providers/get-chatbot-knowledge-index'
export const REQUEST_CHATBOT_KNOWLEDGE_ENDPOINT = 'office/providers/request-chatbot-knowledge-index'
export const CHATBOT_KNOWLEDGE_WIDGET_ID = 'chatbot-knowledge-widget'

/** Observed crawls take about four minutes, so this settles well within one. */
export const CRAWL_POLL_INTERVAL_MS = 10_000

export const STATUS_LABEL: Record<KnowledgeIndexStatus, string> = {
    queued: 'Queued',
    running: 'Crawling',
    completed: 'Indexed',
    failed: 'Failed',
    not_found: 'Never crawled',
    no_website: 'No website',
    unknown: 'Unknown',
}

export const STATUS_BADGE_CLASSES: Record<KnowledgeIndexStatus, string> = {
    queued: 'bg-neutral-100 !text-neutral-700',
    running: 'bg-neutral-100 !text-neutral-700',
    completed: 'bg-green-100 !text-green-700',
    failed: 'bg-red-100 !text-red-700',
    not_found: 'bg-amber-100 !text-amber-700',
    no_website: 'bg-neutral-100 !text-neutral-700',
    unknown: 'bg-neutral-100 !text-neutral-700',
}

export const TRIGGER_LABEL: Record<KnowledgeIndexTrigger, string> = {
    manual: 'Provider rescan',
    office: 'Office (admin)',
    setup_completed: 'Wizard completed',
    ai_enabled: 'AI switched on',
    website_changed: 'Website changed',
    premium_signed: 'Premium signed',
    sweep: 'Nightly sweep',
}
